import {Module} from 'vuex';

/**
 * @type {Module}
 */
const billing = {
    namespaced: true,
    state: {
        address_line_1: '',
        address_line_2: '',
        city: '',
        company: '',
        country: '',
        first_name: '',
        last_name: '',
        state: '',
        zip_code: '',
        isSameAsShipping: true,
    },
    mutations: {
        setAddressLine1: (s, value) => s.address_line_1 = value,
        setAddressLine2: (s, value) => s.address_line_2 = value,
        setCity: (s, value) => s.city = value,
        setCompany: (s, value) => s.company = value,
        setCountry: (s, value) => s.country = value,
        setFirstName: (s, value) => s.first_name = value,
        setLastName: (s, value) => s.last_name = value,
        setState: (s, value) => s.state = value,
        setZipCode: (s, value) => s.zip_code = value,
        setSameAsShipping: (s, value) => s.isSameAsShipping = value,
    },
    actions: {
        replaceState: ({ commit }, {
            address_line_1 = '',
            address_line_2 = '',
            city = '',
            company = '',
            country = '',
            first_name = '',
            last_name = '',
            state = '',
            zip_code = '',
        }) => {
            commit('setAddressLine1', address_line_1);
            commit('setAddressLine2', address_line_2);
            commit('setCity', city);
            commit('setCompany', company);
            commit('setCountry', country);
            commit('setFirstName', first_name);
            commit('setLastName', last_name);
            commit('setState', state);
            commit('setZipCode', zip_code);
        }
    }
};

export default billing;
